export var SCROLL_DEBOUNCE_MS = 150;
export var SEARCH_DEBOUNCE_MS = 200;
export var VIEWPORT_PADDING = 250;
export var VIEWPORT_SIZE = 500;
//# sourceMappingURL=Constants.js.map